import { Menu, MenuItem } from '@mui/material';
import React from 'react';

interface BkDropdownMenuProps {
  menuItems: { onClick: () => void; label: string }[];
  anchorEl: HTMLElement | null;
  open: boolean;
  onClose: () => void;
}

const BkDropdownMenu: React.FC<BkDropdownMenuProps> = ({
  menuItems,
  anchorEl,
  open,
  onClose,
}) => {
  return (
    <Menu anchorEl={anchorEl} open={open} onClose={onClose}>
      {menuItems.map((item) => {
        return (
          <MenuItem key={`menu_item_${item.label}`} onClick={item.onClick} sx={{fontFamily: 'Instrument Sans'}}>
            {item.label}
          </MenuItem>
        );
      })}
    </Menu>
  );
};

export default BkDropdownMenu;
